import { render, staticRenderFns } from "./destuffpass.vue?vue&type=template&id=27a72cac&scoped=true&"
import script from "./destuffpass.vue?vue&type=script&lang=js&"
export * from "./destuffpass.vue?vue&type=script&lang=js&"
import style0 from "./destuffpass.vue?vue&type=style&index=0&id=27a72cac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a72cac",
  null
  
)

export default component.exports